<template>
  <v-card class="auto" min-height="100px">
    <span class="subtitle-1 font-weight-bold departure"> {{departureTime}} - {{arrivalTime}}</span> 
    <span class="duration">{{duration}}</span>
    <div >
      <span v-for="(leg, index) in travel_data.legs">
        <leg-icon :leg="leg" :last_leg="index + 1 == travel_data.legs.length"></leg-icon>
      </span>
    </div>
  </v-card>
  

</template>

<script>
import Vuetify from 'vuetify';
import LegIcon from './LegIcon.vue'
import moment from 'moment';


export default {
  components: {
      LegIcon,
  },
  props: ['travel_data'],
  data() {
    return {
      test: ""
    }
  },
  computed: {
    departureTime: function() {
      return moment(this.travel_data.startTime).format('HH:mm');
    },

    arrivalTime: function() {
      return moment(this.travel_data.endTime).format('HH:mm');
    },

    duration: function() {
      var result = '';
      const tmp_duration = this.travel_data.duration;
      const hours_traveltime = Math.floor(tmp_duration / 3600);
      const minutes_traveltime = Math.floor((tmp_duration % 3600) / 60);
      if (hours_traveltime > 0) {
        result += hours_traveltime + ' u. ';
      }
      result += minutes_traveltime + " min.";
      return result;
    }
  },
};

</script>
<style scoped>
  .departure {
  margin: 20px;
}

.duration {
  margin-left: 20px;
  align: left;
}

div {
  margin: 10px;
  line-height: 180%;
}
</style>